import React from "react";

function SafexpayPayoutErrorCodes() {
  return (
    <div class="idocs-content">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <section id="idocs_content">
              <h1>Safexpay Payout Error Codes</h1>
              <hr />

              <table className="table table-bordered table-responsive">
                <tr className="bg-yellow">
                  <th>SP Status Code </th>
                  <th>SP Status </th>
                  <th>SP Status Description</th>
                  <th>Remarks</th>
                  <th>Business Decline/Technical Decline</th>
                  {/* <th>Actions for Merchants</th>
                     <th>code+desc</th> */}
                </tr>
                <tr>
                  <td>0000</td>
                  <td>SUCCESS</td>
                  <td className="bg-gray">SPCD_1000-Txn successful</td>
                  <td>Transaction successfully credited to beneficiary</td>
                  <td>___</td>
                </tr>
                <tr>
                  <td>0001</td>
                  <td>PENDING</td>
                  <td className="bg-gray">SPCD_1001-Pending at bank</td>
                  <td>Transaction pending at beneficiary bank</td>
                  <td>___</td>
                </tr>
                <tr>
                  <td>0002</td>
                  <td>FAILED</td>
                  <td className="bg-gray">
                    SPCD_1002-A/C blocked/frozen/closed
                  </td>
                  <td>Beneficiary account frozen/closed/blocked</td>
                  <td>BD</td>
                </tr>
                <tr>
                  <td>0002</td>
                  <td>FAILED</td>
                  <td className="bg-gray">SPCD_1003-Duplicate txn</td>
                  <td>Duplicate Transaction</td>
                  <td>BD</td>
                </tr>
                <tr>
                  <td>0002</td>
                  <td>FAILED</td>
                  <td className="bg-gray">SPCD_1004-Failed at bank</td>
                  <td>Transaction Failed</td>
                  <td>TD</td>
                </tr>
                <tr>
                  <td>0002</td>
                  <td>FAILED</td>
                  <td className="bg-gray">
                    SPCD_1005-Failed at bank - A/C limit exceeded
                  </td>
                  <td>Transaction failed at beneficiary bank</td>
                  <td>BD</td>
                </tr>
                <tr>
                  <td>0002</td>
                  <td>FAILED</td>
                  <td className="bg-gray">
                    SPCD_1006-Failed at bank - Beneficiary bank down
                  </td>
                  <td>Beneficiary bank services unavailable</td>
                  <td>BD</td>
                </tr>
                <tr>
                  <td>0002</td>
                  <td>FAILED</td>
                  <td className="bg-gray">
                    SPCD_1007-Failed at bank - Txn received after cut off
                  </td>
                  <td>Transaction received after cut-off time</td>
                  <td>BD</td>
                </tr>
                <tr>
                  <td>0002</td>
                  <td>FAILED</td>
                  <td className="bg-gray">
                    SPCD_1008-Failed at bank - IMPS Switch
                  </td>
                  <td>IMPS switch down</td>
                  <td>BD</td>
                </tr>
                <tr>
                  <td>0002</td>
                  <td>FAILED</td>
                  <td className="bg-gray">
                    SPCD_1009-Foreign inward remittance not allowed
                  </td>
                  <td>
                    Foreign remittance not allowed in beneficiary account{" "}
                  </td>
                  <td>BD</td>
                </tr>
                <tr>
                  <td>0002</td>
                  <td>FAILED</td>
                  <td className="bg-gray">
                    SPCD_1010-Invalid A/C or IFSC details
                  </td>
                  <td>Incorrect account number or IFSC code</td>
                  <td>BD</td>
                </tr>
                <tr>
                  <td>0002</td>
                  <td>FAILED</td>
                  <td className="bg-gray">SPCD_1011-Invalid txn details</td>
                  <td>Invalid Transaction</td>
                  <td>BD</td>
                </tr>
                <tr>
                  <td>0002</td>
                  <td>FAILED</td>
                  <td className="bg-gray">
                    SPCD_1012-Invalid txn - Invalid currency
                  </td>
                  <td>Invalid Currency</td>
                  <td>BD</td>
                </tr>
                <tr>
                  <td>0002</td>
                  <td>FAILED</td>
                  <td className="bg-gray">
                    SPCD_1013-Txn not allowed in A/C - NRE A/C
                  </td>
                  <td>Beneficiary Account is NRE account</td>
                  <td>BD</td>
                </tr>
                <tr>
                  <td>0002</td>
                  <td>FAILED</td>
                  <td className="bg-gray">SPCD_1014-Txn not allowed in A/C</td>
                  <td>Transaction not allowed in Beneficary account</td>
                  <td>BD</td>
                </tr>
                <tr>
                  <td>0002</td>
                  <td>FAILED</td>
                  <td className="bg-gray">
                    SPCD_1015-Invalid A/C or IFSC details - Beneficiary name
                    mismatch
                  </td>
                  <td>Beneficiary account name mismatch as per records</td>
                  <td>BD</td>
                </tr>
                <tr>
                  <td>0000</td>
                  <td>SUCCESS</td>
                  <td className="bg-gray">SPCD_1016-Txn successful</td>
                  <td>Manual Success given Due to Deemed Success from bank</td>
                  <td>___</td>
                </tr>
                <tr>
                  <td>0000</td>
                  <td>SUCCESS</td>
                  <td className="bg-gray">
                    SPCD_1017-Awaiting confirmation from beneficiary bank
                  </td>
                  <td>UTR generated; awaited final status confirmation</td>
                  <td>___</td>
                </tr>
                <tr>
                  <td>0003</td>
                  <td>REVERSAL</td>
                  <td className="bg-gray">SPCD_1018-Txn reversed at bank</td>
                  <td>Transaction reversed</td>
                  <td>BD</td>
                </tr>
                <tr>
                  <td>0002</td>
                  <td>FAILED</td>
                  <td className="bg-gray">
                    SPCD_1019-Failed at bank - business decline
                  </td>
                  <td>Transaction declined at NPCI switch</td>
                  <td>BD</td>
                </tr>
                <tr>
                  <td>0002</td>
                  <td>FAILED</td>
                  <td className="bg-gray">
                    SPCD_1020-Failed at bank - technical decline
                  </td>
                  <td>Transaction declined at bank</td>
                  <td>TD</td>
                </tr>
              </table>
              <ul
                style={{ listStyleType: "none", listStylePosition: "inside",padding:0 }}
              >
                <li>
                  <b>0000 – Successful</b>
                </li>
                <li>
                  <b>0001 – Pending</b>
                </li>
                <li>
                  <b>0002 – Failed</b>
                </li>
                <li>
                  <b>0003 – Reversal</b>
                </li>
              </ul>
              <p>
                <b>BD – Business Decline</b> - Transactions which were processed
                by the payment systems but got declined because of any user
                input, like incorrect account no, invalid bank details, etc. The
                commission amounts get levied for such cases.
              </p>
              <p>
                <b>TD – Technical Decline</b> - Transactions which got captured
                at Safexpay but failed due to technical reasons at processing
                bank, RBI/NPCI or beneficiary bank. The commission amount for
                such scenarios are not levied by Safexpay.
              </p>
              <h6>Note: </h6>
              <ul
                style={{ listStyleType: "none", listStylePosition: "inside",padding:0 }}
              >
                <li>
                  1. In “SPCD_1017-Awaiting confirmation from beneficiary bank”,
                  transaction would be marked and considered as Deemed Success
                </li>
                <li>
                  2. <b>"Status Code", "Status" and "Status Description"</b> are
                  the parameters from API Responses.
                </li>
                <li>
                  3. No changes required for already integrated merchants.
                </li>
              </ul>
            </section>
          </div>
          <div class="col-md-4"></div>
        </div>
      </div>
    </div>
  );
}
export default SafexpayPayoutErrorCodes;
